import script from "./ExpandingTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandingTextField.vue?vue&type=script&setup=true&lang=ts"

import "./ExpandingTextField.vue?vue&type=style&index=0&id=2382e706&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2382e706"]])

export default __exports__